import {
  SofturaTable,
  PrimaryButton,
  Label,
  DropdownBox,
  ModalPopup,
  Row,
  Col,
  PopupDialogbox,
} from "client/CommonComponents";
import "./ApplicationPermission.scss";
import MoreOptions from "client/CommonComponents/MoreOptions";
import AddApplicationPermission from "./AddApplicationPermissionModal/AddApplicationPermission-Container"
import { useSelector } from "react-redux";
import userManageSelectors from '../../../../../redux/UserManagement/selectors';
import { ACCESS_DENIED } from "client/utils/Permissions";

const ApplicationPermission = ({
  optionHandler,
  handleApplicationChange,
  handleAppAreachange,
  togglePopup,
  showAppPerPopup,
  handleClickSave,
  showDeleteModal,
  handleDeleteClick,
  appPerName,
  showInfoModal,
  handleInfoModal,
  handleChange,
  formError,
  form,
  setForm,
  handleDeleteModal,
  Popupcontent  
}: any) => {
  const {
    appAreaDropdownVal,
    checkAppPermission,
    addAppPerVal,
    appNameDropDownVal,
    appPermissionListing,
    appPermissionById,
  }: any
    = useSelector(
      (state: any) => ({
        appAreaDropdownVal: state.UserManagement.activeAppAreaData,
        checkAppPermission: userManageSelectors.checkAppPermission(state),
        addAppPerVal: userManageSelectors.addAppPerVal(state),
        appNameDropDownVal: state.UserManagement.activeApplicationData,
        appPermissionListing: userManageSelectors.appPermissionListing(state),
        deleteAppPermission: userManageSelectors.deleteAppPermission(state),
        appPermissionById: userManageSelectors.appPermissionById(state)
      })
    )
  const option = [
    {
      title: "Edit Security Permission",
      value: "editSecurityPermission",
    },
    {
      title: "Delete Security Permission",
      value: "deleteSecurityPermission",
    },
  ];
  const categoryColumns = [
    {
      key: "action",
      title: "Action",
      Cell: (row: any) => {
        return (
          <>
            <MoreOptions
              onClick={optionHandler}
              options={option}
              {...row.rowData}
             data-attribute="ApplicationPermission_Default_MoreOptions" />
          </>
        );
      },
      width: 50,
    },
    {
      key: "permissionName",
      title: "Permission Name",
      width: 200,
    },
    {
      key: "applicationName",
      title: "Application Name",
      width: 200,
    },
    {
      key: "appAreaName",
      title: "Application Area",
      width: 200,
    },
    {
      key: "permissionDescription",
      title: "Permission Description",
      width: 200,
    },
  ];
  const handlePermission = (status?: boolean) => {    
      if (status) {
        return (
          <div className="access-denied">
            <h1>ACCESS DENIED</h1>
            <h6>{ACCESS_DENIED}</h6>
          </div>
        );
      } else {
        return (
          <>
            <div>
              <h5 className="headingClass">Application Permission</h5>
            </div>
            <div className="appPermissionClass">
              <div className="app-permission-header">
                <Row className="mb-3">
                  <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <Label required data-attribute="ApplicationPermission_Default_Label">Application</Label>
                    <DropdownBox
                      name="application"
                      placeholder="Select"
                      options={appNameDropDownVal?.length > 0 ? appNameDropDownVal : [{ text: "Select Application", value: null }]}
                      onChange={handleApplicationChange}
                     data-attribute="ApplicationPermission_application_Dropdown" />
                  </Col>
                  <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <Label required data-attribute="ApplicationPermission_Default_Label_2">App Area</Label>
                    <DropdownBox
                      name="appArea"
                      placeholder="Select"
                      options={appAreaDropdownVal?.length > 0 ? appAreaDropdownVal : [{ text: "Select App Area", value: null }]}
                      onChange={handleAppAreachange}
                     data-attribute="ApplicationPermission_appArea_Dropdown" />
                  </Col>
                  <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <PrimaryButton
                      text="Add"
                      className="pull-right Add-button"
                      onClick={() => togglePopup()}
                     data-attribute="ApplicationPermission_Default_Button" />
                  </Col>
                </Row>
              </div>
              <div
                className={
                  appPermissionListing?.data?.length !== 0
                    ? "softura-table "
                    : "softura-table paginationNav"
                }
              >
                <SofturaTable
                  data={appPermissionListing?.data ?? []}
                  columns={categoryColumns}
                  sort={true}
                  defaultPageSize={10}
                  pageSizes={[10, 20, 50]}
                  globalSearch={false}
                  filter={true}
                 data-attribute="ApplicationPermission_Default_Grid" />
              </div>
              {showAppPerPopup ? (
                <ModalPopup
                  ShowModalPopupFooter={true}
                  ModalPopupTitle={appPermissionById.hasOwnProperty("id") && appPermissionById?.id > 0 ? "Edit Application Permission" : "Add New Permission"}
                  ModalPopupType="medium"
                  FooterSecondaryBtnTxt="Cancel"
                  FooterPrimaryBtnTxt="Save"
                  closeModalPopup={togglePopup}
                  PrimaryBtnOnclick={handleClickSave}
                  SecondryBtnOnclick={togglePopup}
                 data-attribute="ApplicationPermission_Default_ModalPopup">
                  <AddApplicationPermission
                    handleChange={handleChange}
                    formError={formError}
                    form={form}
                    applicationDropDown={appNameDropDownVal}
                    setForm={setForm}
                  />
                </ModalPopup>
              ) : null}
              {showDeleteModal ? (
                <ModalPopup
                  ShowModalPopupFooter={true}
                  ModalPopupTitle="Confirmation"
                  ModalPopupType="medium"
                  FooterSecondaryBtnTxt="No"
                  FooterPrimaryBtnTxt="Yes"
                  closeModalPopup={handleDeleteModal}
                  PrimaryBtnOnclick={handleDeleteClick}
                  SecondryBtnOnclick={handleDeleteModal}
                 data-attribute="ApplicationPermission_Default_ModalPopup_2">
                  <Label data-attribute="ApplicationPermission_Default_Label_3">Are you sure you want to delete "{appPerName}" ?</Label>
                </ModalPopup>
              ) : (
                ""
              )}
              <div className="appPerInfo-Modal">
                {showInfoModal ? (
                  <ModalPopup
                    ShowModalPopupFooter={true}
                    ModalPopupTitle="Information"
                    ModalPopupType="medium"
                    FooterPrimaryBtnTxt="Ok"
                    closeModalPopup={handleInfoModal}
                    PrimaryBtnOnclick={handleInfoModal}
                   data-attribute="ApplicationPermission_Default_ModalPopup_3">
                    <Label data-attribute="ApplicationPermission_Default_Label_4">Successfully deleted "{appPerName}"</Label>
                  </ModalPopup>
                ) : (
                  ""
                )}
              </div>
              {addAppPerVal > 0 || checkAppPermission || addAppPerVal == "error" ? (
                <PopupDialogbox
                  hideDialog={!Popupcontent.isDialogVisible}
                  onDismiss={() => Popupcontent?.popupOutlinebtnOnclick()}
                  Popupcontent={Popupcontent}
                  popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                  popupPrimarybtnOnclick={(
                    item: any,
                    actionby: string,
                    value: any
                  ) => Popupcontent?.popupPrimarybtnOnclick(item, actionby, value)}
                 data-attribute="ApplicationPermission_Default_PopupDilalogBox" />
              ) : null}
            </div>
          </>
        );
      }
    }  
  return (
    <div className="AppHeader">
      {handlePermission(true)}
    </div>
  );
};

export default ApplicationPermission;
